import { colorAdapter } from '@extensions/AttributePanel/components/adapter';
import React, { ComponentProps } from 'react';
import { isMergeTagExpression } from '@bay-email/core';
import { ColorPickerControl, ColorPickerControlProps } from '../ColorPickerControl';
import { DynamicLabelPill } from '../DynamicLabelPill';
import enhancer from '../enhancer';

const ColorPickerFieldSource = enhancer<ColorPickerControlProps>(
	ColorPickerControl,
	e => e,
	{
		debounceTime: 1,
	},
);

export const ColorPickerField = (
	props: ComponentProps<typeof ColorPickerFieldSource>,
) => {
	return (
		<ColorPickerFieldSource
			config={colorAdapter}
			// Show the "{ } Dynamic" pill inline with the label when dynamic mode is
			// enabled and the stored value is a merge tag (e.g. "{{user.brandPrimaryColor}}").
			renderLabelSuffix={(value: string) =>
				props.supportsDynamic !== false && isMergeTagExpression(value)
					? <DynamicLabelPill />
					: null
			}
			{...props}
			// Marker class so every color field spans the full drawer width regardless of
			// the surrounding Grid.Col (see the full-width rule in BayColorPicker.scss).
			// Merged last so it always applies, while preserving any caller className.
			formItem={{
				...(props.formItem || {}),
				className: ['bay-color-picker-field', props.formItem?.className]
					.filter(Boolean)
					.join(' '),
			}}
		/>
	);
};
